module.exports = __webpack_public_path__ + "img/message-system@2x.af4f05d5.png";